// extracted by mini-css-extract-plugin
export default {"interactive_off":"EditableValue_interactive_off__PILEk","interactive_on":"EditableValue_interactive_on__4ggt5","input":"EditableValue_input__a5sOy"};